class SectionShopAllHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper, Navigation, FreeMode }) => {
      const swiperParams = {
        modules: [FreeMode],
        speed: 600,
        slidesPerView: "auto",
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: this.querySelector('[data-swiper-next]'),
          prevEl: this.querySelector('[data-swiper-previous]'),
        },
        freeMode: {
          enabled: true,
          sticky: false,
          momentumBounce: false,
        }
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }

  disconnectedCallback() {

  }
}

if (!customElements.get("section-shop-all-hero")) {
  customElements.define("section-shop-all-hero", SectionShopAllHero);
}
